export default "__VITE_ASSET__DVP1C2Of__"